import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './AdminUsers.css';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/admin/users').then(({ data }) => setUsers(data)).finally(() => setLoading(false));
  }, []);

  const toggleAdmin = async (user) => {
    const newVal = !user.isAdmin;
    if (!window.confirm(`${newVal ? 'Grant' : 'Revoke'} admin access for "${user.name}"?`)) return;
    try {
      const { data } = await api.put(`/admin/users/${user._id}`, { isAdmin: newVal });
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, isAdmin: data.isAdmin } : u));
      toast.success(`Admin access ${newVal ? 'granted' : 'revoked'}`);
    } catch {
      toast.error('Update failed');
    }
  };

  const deleteUser = async (user) => {
    if (!window.confirm(`Delete user "${user.name}"? This cannot be undone.`)) return;
    try {
      await api.delete(`/admin/users/${user._id}`);
      setUsers(prev => prev.filter(u => u._id !== user._id));
      toast.success('User deleted');
    } catch {
      toast.error('Delete failed');
    }
  };

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="admin-page-title">Users</div>
      <p className="admin-page-sub">{users.length} registered users</p>

      <div className="admin-filters" style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 340 }}>
          <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
          <input className="form-input" style={{ paddingLeft: 42 }} placeholder="Search users..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      <div className="admin-table-wrap">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(user => (
                <tr key={user._id}>
                  <td>
                    <div className="user-cell">
                      <div className="user-mini-avatar">{user.name.charAt(0).toUpperCase()}</div>
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td className="email-cell">{user.email}</td>
                  <td>{user.phone || <span className="na">—</span>}</td>
                  <td>
                    {user.isAdmin
                      ? <span className="badge badge-purple">⚡ Admin</span>
                      : <span className="badge badge-blue">Customer</span>
                    }
                  </td>
                  <td className="date-cell">{new Date(user.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="action-btns">
                      <button
                        className={`action-btn ${user.isAdmin ? 'delete' : 'edit'}`}
                        title={user.isAdmin ? 'Revoke Admin' : 'Grant Admin'}
                        onClick={() => toggleAdmin(user)}
                      >
                        {user.isAdmin ? '🔒' : '⚡'}
                      </button>
                      <button className="action-btn delete" title="Delete User" onClick={() => deleteUser(user)}>
                        🗑
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {!loading && filtered.length === 0 && (
          <div className="table-empty">No users found.</div>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;
